import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CompanyInfoPage } from './companyInfo';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    CompanyInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(CompanyInfoPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class CompanyInfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/companyInfo/companyInfo.module.ts